import { collapseUnion, TestRunConfig } from '@feedyou/utils'
import { getHistory } from '@features/appRouting'

import { feedbotToast } from '../../lib/feedbotToast'
import { StoreApi } from '../../store/types'
import { scenarioSelector } from './selectors'
import { Button } from '../../components/design-system/Button'
import { getScenarioListHref } from '../../components/TopHeader/TopHeaderTabs/Tabs/BotTesterTab'
import { Spacer } from '../../components/design-system/Spacer'

export function toastNotifyRunSuccess(config: TestRunConfig<any>, api: StoreApi) {
  const { scenarioId, botId } = collapseUnion(config)

  if (botId && scenarioId) {
    const scenario = scenarioSelector(botId, scenarioId)(api.getState())

    feedbotToast.success({
      id: `test-run-success-${scenarioId}`,
      title: `Test run for scenario ${scenario?.name ?? scenarioId} passed`,
      content: 'You can now view the run details'
    })
  }
}

export function toastNotifyRunError(config: TestRunConfig<any>, api: StoreApi) {
  const { scenarioId, botId } = collapseUnion(config)

  if (botId && scenarioId) {
    const scenario = scenarioSelector(botId, scenarioId)(api.getState())

    feedbotToast.error({
      id: `test-run-error-${scenarioId}`,
      title: `Test run for scenario ${scenario?.name ?? scenarioId} failed`,
      content: 'View the run details to see run details'
    })
  }
}

export function toastNotifyCreateScenarioSuccess(botId: string) {
  feedbotToast.success({
    id: `test-run-success`,
    title: 'Scenario successfully created.',
    content: (
      <>
        A new test scenario for current conversation was successfully created.
        <Spacer display="block" height="10px" width="15px" />
        <Button
          size="small"
          label="Go to scenarios"
          emphasis="primary"
          onClick={() => getHistory().push(getScenarioListHref(botId))}
        />
      </>
    )
  })
}

export function toastNotifyCreateScenarioFailure() {
  feedbotToast.success({
    id: `test-run-failure`,
    title: 'Error creating a test scenario',
    content: 'We encountered an issue with creating a test scenario.'
  })
}
